export default __webpack_public_path__ + "static/media/default-check.e81f5dc5.svg";